<template>
  <div class="ts-overflow-hidden">
    <!-- <ts-loading-banner :loading="loadingPhoto"> -->
    <div
      style="height: 75vh"
      class="ts-overflow-y-auto ts-overflow-x-hidden ts-mt-4 drive-wrapper drive-grid-view ts-rounded-md"
    >
      <div v-if="isHasPhoto">
        <div class="tab-pane fade show active grid-items-wrapper">
          <h2
            class="m-t-5 m-b-5 ts-sticky ts-top-0 ts-z-10 ts-p-2 ts-opacity-90 ts-font-bold ts-font-sans ts-text-sm ts-flex ts-justify-between"
            style="text-shadow: 0 0 3px #fff, 0 0 5px #fff; background: #f5f5f5"
          >
            <div class="ts-flex ts-justify-start">
              {{ record[0].event_date_group_by }}
            </div>
          </h2>
          <div class="row row-space-2" v-viewer>
            <div
              class="col-lg-1 col-sm-2 col-3"
              v-for="(items, index) in record"
            >
              <a
                class="widget-card square m-b-2 photo-wrapper"
                @contextmenu.prevent="onRightClick($event, items)"
              >
                <img
                  class="widget-card-cover"
                  v-lazy="{
                    src: photo(items),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </a>
            </div>
            <div>
              <VueFileAgent
                :multiple="true"
                :accept="'image/*'"
                :maxSize="'10MB'"
                :maxFiles="10"
                v-if="!reloadVueFileagent"
                :helpText="'Choose images or files'"
                @select="value => filesSelected(value)"
              >
              </VueFileAgent>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin: auto; width: 300px; margin-top: 150px">
        <img :src="require('@/assets/cover-scrum-board.png')" />
        <h1 class="text-center ts-text-4xl ts-font-bold ts-opacity-25">
          No Photo
        </h1>
      </div>
      <vue-context ref="menu">
        <li v-for="(m, i) in menus" :key="i">
          <a href="#" @click.prevent="handle_function_call(m.action_name)"
            ><i class="ts-mr-3" :class="m.icon"></i> {{ m.name }}</a
          >
        </li>
      </vue-context>
    </div>
    <!-- </ts-loading-banner> -->
  </div>
</template>

<script>
import VueContext from 'vue-context'
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)
import { Errors } from 'form-backend-validation'
import Vue from 'vue'
import { isEmpty } from 'lodash'
import info from './components/info'
import * as FileDownload from 'downloadjs'
import moment from 'moment'
import httpClient from '@/http-client'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

export default {
  name: 'viewPhoto',
  props: ['resource'],
  components: { VueContext, info },
  data () {
    return {
      reloadVueFileagent: false,
      errors: new Errors(),
      loading: false,
      // loadingPhoto: false,
      visible: false,
      model: {},
      menus: [
        {
          name: 'Download',
          action_name: 'download',
          icon: 'fas fa-download'
        },
        {
          name: 'Delete',
          action_name: 'delete',
          icon: 'fas fa-trash'
        },
        {
          name: 'Info',
          action_name: 'info',
          icon: 'fas fa-info-circle'
        }
      ]
    }
  },
  computed: {
    countItems: () => items => {
      return Object.values(items).length
    },
    isHasPhoto () {
      return !isEmpty(this.record)
    },
    isStaff () {
      return this.$store.getters.isStaffLogin
    },
    isTeacher () {
      return this.$store.getters.isTeacherLogin
    },
    record () {
      return this.resource
    }
  },
  methods: {
    photo (record) {
      if (record.file_path) {
        return record.file_path
      }
      return require('@/assets/default_user.jpg')
    },
    onRightClick (e, item) {
      this.$refs.menu.open(e, item)
      this.model = item
    },
    handle_function_call (function_name) {
      this[function_name]()
    },
    async filesSelected (files) {
      this.errors = new Errors()
      this.waiting = true

      var fileUpload = await Promise.all(
        files.map(item => {
          let frm = new FormData()
          frm.append('file', item.file)
          return httpClient.post('/api/student-galleries/upload-files', frm)
        })
      )

      var filePaths = fileUpload.map(file => file.data)
      this.$store
        .dispatch('staffStudentGallery/store', {
          event_date: moment(this.record[0].event_date, 'YYYY-MM-DD').format(
            'DD-MM-YYYY'
          ),
          class_id: this.record[0].class_id,
          upload_id: this.record[0].upload_id,
          event_name: this.record[0].event_name,
          attach_file_list: filePaths
        })
        .then(response => {
          this.reloadVueFileagent = true
          this.$nextTick(() => {
            this.reloadVueFileagent = false
          })
          this.$emit('fetchPhoto')
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    download () {
      FileDownload(this.model.file_path)
    },
    info () {
      this.visible = true
    }
  }
}
</script>
<style scoped lang="scss">
.drive-wrapper {
  padding-top: 0 !important;
  background: #f5f5f5;
}

.photo-wrapper {
  background: #fff;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.photo-wrapper:hover img {
  padding: 5px;
  opacity: 0.8;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
</style>
